import { Flex, useStyles } from '@archipro-design/aria';
import * as S from '@modules/project/component/about-professional/Locations.style';
import { Link } from '@remix-run/react';
import { useHasSavedCoords } from '@modules/professional/hook/use-locations-sort-by-distance';
import type { Coordinate } from '~/modules/location/hook/use-current-coordinates';
import NearestLocation from '@modules/project/component/about-professional/NearestLocation';
import { useClickToReveal } from '~/modules/root/hook/use-click-to-reveal';
import { PROFESSIONAL_SECTIONS_ANCHOR } from '~/modules/professional/util/constants';

export interface ProfessionalLocation {
    MapCoordinates?: Coordinate;
    distance?: number;
    Suburb?: string | null;
    City?: string | null;
    Region?: string | null;
    LocationHidden?: boolean;
}

interface LocationsProps {
    locations: ProfessionalLocation[];
    profilePage: string;
    professionalID: number;
}

export const resolveSuburbCity = (
    location: ProfessionalLocation | undefined
) => {
    const { Suburb, City, Region } = location ?? {};
    return [Suburb, Region ?? City].filter(Boolean).join(', ');
};

const Locations = ({
    locations,
    profilePage,
    professionalID,
}: LocationsProps) => {
    const { css } = useStyles();
    const hasSavedCoords = useHasSavedCoords();
    const canRequestLocation = false;

    const { onRevealClick } = useClickToReveal({
        revealType: 'Location',
        revealKey: `professional-${professionalID}`,
    });

    return (
        <Flex data-testid="location" className={css(S.Locations)}>
            <>
                {hasSavedCoords || canRequestLocation ? (
                    <NearestLocation locations={locations} />
                ) : (
                    <Link
                        to={`${profilePage}/contact#${PROFESSIONAL_SECTIONS_ANCHOR}`}
                        className={css(S.MultipleLocations)}
                        style={{ textDecoration: 'underline' }}
                        onClick={() => onRevealClick()}
                    >
                        {locations.length > 1
                            ? `View all locations (${locations.length})`
                            : 'View address'}
                    </Link>
                )}
            </>
        </Flex>
    );
};

export default Locations;
